import Immutable from 'immutable';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  objType: string,
  subType: string,
  value: number
} = {
  objType: 'TypedInteger',
  subType: 'UInt32',
  value: 0
};

class TypedInteger extends Immutable.Record(Content) {
  static fromJS (json: object): TypedInteger {
    return ClassFactory.createFromJson(json, TypedInteger);
  }

  static createUInt8 (value: number): TypedInteger {
    return new TypedInteger({subType: 'UInt8', value: value});
  }

  static createUInt16 (value: number): TypedInteger {
    return new TypedInteger({subType: 'UInt16', value: value});
  }

  static createUInt32 (value: number): TypedInteger {
    return new TypedInteger({subType: 'UInt32', value: value});
  }

  static createUInt64 (value: number): TypedInteger {
    return new TypedInteger({subType: 'UInt64', value: value});
  }

  static createInteger (value: number): TypedInteger {
    return new TypedInteger({subType: 'Integer', value: value});
  }

  static createLong (value: number): TypedInteger {
    return new TypedInteger({subType: 'Long', value: value});
  }

  static createShort (value: number): TypedInteger {
    return new TypedInteger({subType: 'Short', value: value});
  }
}

export default TypedInteger;
